import { roundPrice } from '../index'

export const getDepositsSum = (deposits) => {
	return deposits?.length ? roundPrice(deposits.reduce((res, el) => res + el.total, 0)) : 0
}
